import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import { apiSlice } from './apiSlice';
import customerAuthReducer from './customerAuthSlice';
import { customersApi } from './customersApi';
import { ordersApi } from './ordersApi';
import { settingsApi } from './settingsApi';

export const store = configureStore({
  reducer: {
    cart:                        cartReducer,
    customerAuth:                customerAuthReducer,
    [apiSlice.reducerPath]:      apiSlice.reducer,
    [customersApi.reducerPath]:  customersApi.reducer,
    [ordersApi.reducerPath]:     ordersApi.reducer,
    [settingsApi.reducerPath]:   settingsApi.reducer,
  },
  middleware: (getDefault) => getDefault().concat(apiSlice.middleware, customersApi.middleware, ordersApi.middleware, settingsApi.middleware),
});

export type RootState   = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
